import { useState } from 'react'
import { Microphone2 } from 'iconsax-react'
import { useTheme } from '@mui/material'

import {
  SPEECH_TO_TEXT_COMMAND,
  SUPPORT_SPEECH_RECOGNITION
} from '../SpeechToTextPlugin'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'

export default function ActionsPlugin (): JSX.Element {
  const theme = useTheme()

  const [editor] = useLexicalComposerContext()
  const [isSpeechToText, setIsSpeechToText] = useState(false)

  return (
    <div className='actions'>
      {SUPPORT_SPEECH_RECOGNITION && (
        <button
          onClick={() => {
            editor.dispatchCommand(SPEECH_TO_TEXT_COMMAND, !isSpeechToText)
            setIsSpeechToText(!isSpeechToText)
          }}
          className={
            'action-button action-button-mic ' +
            (isSpeechToText ? 'active' : '')
          }
          title='Speech To Text'
          aria-label={`${isSpeechToText ? 'Enable' : 'Disable'} speech to text`}
        >
          <Microphone2 size={theme.size.xl} />
        </button>
      )}
    </div>
  )
}
